module.exports = __webpack_public_path__ + "assets/search.a8a999fe.svg";